import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { ToastModule } from "primeng/toast";
import { MessageService } from "primeng/api";

import { AppRoutingModule } from "./app-routing.module";
import { CoreModule } from "@core/core.module";

import { AppComponent } from "@app/app.component";
import { HeaderComponent } from "@layout/header/header.component";

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    ToastModule,
    HeaderComponent,
  ],
  providers: [MessageService],
  bootstrap: [AppComponent],
})
export class AppModule {}
